import { gql } from "apollo-boost";

export const CREATE_CATEGORY = gql`
mutation CreateCategory($data: CategoryInput!) {
    createCategory(data: $data) {
      message
      id
    }
  }
`;


export const UPDATE_CATEGORY = gql`
mutation UpdateCategory($data: CategoryInput!, $where: CategoryWhereInputOne!) {
  updateCategory(data: $data, where: $where) {
    message
  }
}
`;


export const DELETE_CATEGORY = gql`
mutation DeleteCategory($where: CategoryWhereInputOne!) {
  deleteCategory(where: $where) {
    message
  }
}
`;
